module.exports = {
  convert: (number, language = "en", formatObj = {}) => {
    return new Intl.NumberFormat(language, formatObj).format(number)
  },
  formatCurrency: (number, locale, currency) => {
    const currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    })
    return currencyFormat.format(number)
  },
  formatCurrencyOnlySymbol: (number, locale, currency) => {
    const currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "narrowSymbol",
    })
    return currencyFormat.format(number)
  },
  formatCurrencyOnlySymbolWithoutDecimals: (number, locale, currency) => {
    const currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 0,
    })
    return currencyFormat.format(number)
  },
  getCurrencySymbol: (locale, currency) => {
    const format = {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }
    return (0).toLocaleString(locale, format).replace(/\d/g, "").trim()
  },
  /*
	Symbol for the American dollar in English
		In general texts
			In an English document, when you need to specify the type of dollar (Canadian, American, Australian, etc.), 
			the Translation Bureau recommends using the symbol US$ to represent the American dollar.

			Write the country symbol (US) first, immediately followed by the dollar sign ($) and the dollar figure:

			US$25.99
			Do not place the dollar sign before the country symbol:

			US$1.65 (not $US1.65)
			Do not put a space between US and the dollar sign:

			US$2.50 (not US $2.50)

		In the area of finance
			In the area of finance, especially in texts discussing currency values and exchange rates, 
			the universal code USD is the usual symbol used.

			USD is the international currency code established by the International Organization for Standardization (ISO) 
			to represent the American dollar. It is composed of the country code (US), followed by the letter "D" for "dollar."

			Write the code first, followed by a non-breaking space and the dollar figure:

			USD 350 million
			CAD 125.00 = USD 121.22, at an exchange rate of 0.9697 [CAD is the international currency code for the Canadian dollar.]
			Note that the dollar sign is redundant if used with the international code USD:

			USD 800 000 (not USD$, USD $, $USD or $ USD)
			Symbol for the American dollar in Frenc
  */
  formatCurrencyFinancial: (number, locale, currency) => {
    const currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
    })
    return currencyFormat.format(number)
  },
  formatCurrencyFinancialToParts: (number, locale, currency) => {
    const currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
    })
    const parts = currencyFormat.formatToParts(number)
    const lastPartIdx = parts.length - 1
    if (parts[0].type === "currency") {
      return [
        {
          type: "symbol",
          value: parts[0].value,
        },
        {
          type: "amount",
          value: parts
            .slice(1)
            .map(p => p.value)
            .join(""),
        },
      ]
    } else if (parts[lastPartIdx].type === "currency") {
      return [
        {
          type: "amount",
          value: parts
            .slice(0, -1)
            .map(p => p.value)
            .join(""),
        },
        {
          type: "symbol",
          value: parts[lastPartIdx].value,
        },
      ]
    } else {
      return [
        {
          type: "amount",
          value: parts.map(p => p.value).join(""),
        },
        {
          type: "symbol",
          value: "",
        },
      ]
    }
  },
  formatDate: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    })
    return dateFormat.format(date)
  },
  formatDateToDayMonth: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "numeric",
    })
    return dateFormat.format(date)
  },
  formatDateToDayLongMonth: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
    })
    return dateFormat.format(date)
  },
  formatDateToShortMonth: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      month: "short",
    })
    return dateFormat.format(date)
  },
  formatDateToShortMonthYear: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      month: "short",
      year: "numeric",
    })
    return dateFormat.format(date)
  },
  formatDateToLongMonthYear: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      month: "long",
      year: "numeric",
    })
    return dateFormat.format(date)
  },
  formatDateToShortDayMonth: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "short",
    })
    return dateFormat.format(date)
  },
  formatDateToMonthYearShort: (date, locale) => {
    const dateFormat = new Intl.DateTimeFormat(locale, {
      month: "short",
      year: "2-digit",
    })
    return dateFormat.format(date)
  },
  formatPercentage: (number, locale, decimals = 0) => {
    const percFormat = new Intl.NumberFormat(locale, {
      style: "percent",
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })
    return percFormat.format(number)
  },
}
